import React from "react";
import "./SwipeImgAnimation.css";

type SwipeImgAnimationProps = {
    src: string; // 画像のURL
    alt?: string; // 画像の説明（任意）
    containerHeight?: string; // コンテナの高さ（デフォルトは200px）
    animationDuration?: string; // アニメーションの時間（デフォルトは3s）
    width?: string;
};

const SwipeImgAnimation = ({
    src,
    alt = "Swipe Animation",
    containerHeight = "100vh",
    animationDuration = "3s",
    width = "50vw"
}: SwipeImgAnimationProps) => (
    <div className="swipe-animation-image-container" style={{ height: containerHeight, zIndex: 1000, width: width, pointerEvents: 'none', overflow: 'hidden' }}>
        <img
        src={src}
        alt={alt}
        className="swipe-animation-image"
        style={{ animationDuration, width: '100%' }}
        />
    </div>
);

export default SwipeImgAnimation;
